import React, { Component } from "react";
import { Route, Routes } from "react-router-dom";
import PageHome from "./pages/PageHome";
import Header from "./components/Header";
import PageGames from "./pages/PageGames";
import Page404 from "./pages/Page404";
import Footer from "./components/Footer";
import PageForDevs from "./pages/PageForDevs";
import RoutesConfig from "./constants/routes.json";
import PageLegalDisclosure from "./pages/PageLegalDisclosure";

class App extends Component {
  constructor(props) {
    super(props);
    this.changeLanguage = this.changeLanguage.bind(this);
  }

  changeLanguage(newLanguage) {
    localStorage.setItem("language", newLanguage);
    this.forceUpdate();
  }

  render() {
    return (
      <div>
        <Header key="header" />
        <Routes>
          <Route path={RoutesConfig.home} element={<PageHome />} />
          <Route path={RoutesConfig.games} element={<PageGames />} />
          <Route path={RoutesConfig.dev} element={<PageForDevs />} />
          <Route path={RoutesConfig.legal} element={<PageLegalDisclosure />} />
          <Route path="*" element={<Page404 />} />
        </Routes>
        <Footer changeLanguage={this.changeLanguage} />
      </div>
    );
  }
}

export default App;
